<template>
  <Details :url="url"></Details>
</template>
<script>
import Details from "../../components/details.vue";

export default {
  components: {
    Details
  },
  data() {
    return {
      url: "sinomed"
    };
  },

};
</script>
<style lang="less">
.Details {
  h2 {
    color: #325156;
  }
  > p {
    color: #929292;
    padding-bottom: 1rem;
    border-bottom: 1px solid #f3f3f3;
  }
  div {
    p {
      margin-top: 0.5rem;
      line-height: 1.5rem;
      span {
        width: 20%;
        display: inline-block;
      }
    }
    > button {
      background: #305359 !important;
      border-color: #305359 !important;
    }
  }
}
</style>
